import { RotateCcw } from "lucide-react";
import { Button } from "@/components/ui/button";
import type { QuizQuestion } from "@/types/quiz";

interface QuestionAnswerSimulatorProps {
  questions: QuizQuestion[];
  selectedAnswers: Record<string, string>;
  onAnswerChange: (questionKey: string, answerId: string | null) => void;
  onReset: () => void;
}

export function QuestionAnswerSimulator({
  questions,
  selectedAnswers,
  onAnswerChange,
  onReset,
}: QuestionAnswerSimulatorProps) {
  const hasSelections = Object.keys(selectedAnswers).length > 0;

  return (
    <div className="space-y-3 rounded-md border bg-muted/20 p-3">
      <div className="flex items-center justify-between">
        <p className="text-sm font-medium">Antwort-Simulation</p>
        <Button
          type="button"
          variant="ghost"
          size="sm"
          onClick={onReset}
          disabled={!hasSelections}
        >
          <RotateCcw className="mr-1 h-3.5 w-3.5" />
          Auswahl zurücksetzen
        </Button>
      </div>

      <div className="grid gap-3 md:grid-cols-2 lg:grid-cols-3">
        {questions.map((q) => {
          const options = q.options ?? [];
          const activeId = selectedAnswers[q.questionKey];
          return (
            <div key={q.questionKey} className="space-y-2">
              <p className="text-xs font-medium text-muted-foreground">
                {q.questionText}
              </p>
              <div className="flex flex-wrap gap-1.5">
                {options.map((opt) => {
                  const isActive = activeId === opt.id;
                  return (
                    <button
                      key={opt.id}
                      type="button"
                      aria-pressed={isActive}
                      onClick={() =>
                        onAnswerChange(
                          q.questionKey,
                          isActive ? null : opt.id,
                        )
                      }
                      className={
                        isActive
                          ? "rounded border border-primary bg-primary px-2.5 py-1 text-xs text-primary-foreground"
                          : "rounded border bg-background px-2.5 py-1 text-xs hover:bg-muted"
                      }
                    >
                      {opt.text}
                    </button>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
